import type { FC, ReactElement } from 'react';

import { cn } from '@shadcn/lib/utils.ts';

export const Loader: FC<{ comment?: string | ReactElement; noBg?: boolean }> = ({
    comment,
    noBg = false,
}) => (
    <div
        role="progressbar"
        aria-label={typeof comment === 'string' ? comment : 'Loading'}
        className={cn(
            'absolute inset-0 z-99 flex flex-col items-center justify-center',
            !noBg && 'bg-background/65 dark:bg-background/85'
        )}
    >
        <div className="relative">
            <div
                aria-hidden="true"
                className="size-16 animate-spin rounded-full border-4 border-current border-t-transparent text-brand motion-reduce:animate-none motion-reduce:border-t-current"
            />
            {comment && (
                <div className="absolute left-1/2 top-full mt-4 -translate-x-1/2 text-muted-foreground">
                    {typeof comment === 'string' ? (
                        <p className="whitespace-nowrap text-16">{comment}</p>
                    ) : (
                        comment
                    )}
                </div>
            )}
        </div>
    </div>
);
